import { add, isAfter, isValid, isWithinInterval } from 'date-fns';
import content from '../locales/en/content.json';

/**
 * Validates the Veteran's age at the declared service period entry date
 * @param {Object} errors - object holding the error message content
 * @param {Object} fieldData - field data from the form input
 * @param {Object} formData - the global data object
 */
export const validateServiceEntryAge = (
  errors,
  fieldData,
  { veteranDateOfBirth },
) => {
  if (!fieldData || !veteranDateOfBirth) return;

  const msg = content['validation-error--service-entry-date'];
  const dobPlus15 = add(new Date(veteranDateOfBirth), { years: 15 });

  if (isAfter(dobPlus15, new Date(fieldData))) {
    errors.addError(msg);
  }
};

/**
 * Validates if insurance policy number or group code is present
 * @param {Object} errors - object holding the error message content
 * @param {Object} fieldData - field data for individual array item
 */
export const validatePolicyNumber = (
  errors,
  { insurancePolicyNumber, insuranceGroupCode },
) => {
  const messages = {
    groupCode: content['validation-error--group-code'],
    policyNumber: content['validation-error--policy-number'],
  };

  if (!insurancePolicyNumber && !insuranceGroupCode) {
    errors.insuranceGroupCode.addError(messages.groupCode);
    errors.insurancePolicyNumber.addError(messages.policyNumber);
  }
};

/**
 * Validates date of birth value for accepted range and valid date format
 * @param {String} dateOfBirth - date string for the Veteran date of birth
 * @returns {String|null} - the valid dates string or null if value is invalid
 */
export const validateDateOfBirth = dateOfBirth => {
  if (!dateOfBirth) return null;

  const birthdate = new Date(dateOfBirth);

  if (!isValid(birthdate)) return null;
  if (
    !isWithinInterval(birthdate, {
      start: new Date('1900-01-01'),
      end: new Date(),
    })
  )
    return null;

  return dateOfBirth;
};
